function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6101 14.71C20.1601 14.94 21.2401 15.49 21.2401 16.6C21.2401 17.37 20.7301 17.87 19.9101 18.18",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.60001 14.27C5.89001 14.27 2.76001 14.95 2.76001 17.69C2.76001 20.43 5.90001 21.21 9.60001 21.21C13.3 21.21 16.44 20.53 16.44 17.79C16.44 15.05 13.3 14.27 9.60001 14.27V14.27Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.59998 12.22C11.98 12.22 13.97 10.17 13.97 7.72999C13.97 5.28999 11.97 3.23999 9.59998 3.23999C7.22998 3.23999 5.22998 5.28999 5.22998 7.72999C5.22998 10.17 7.22998 12.22 9.59998 12.22V12.22Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.26 14.46C11.88 16.22 11.12 17 9.6 17C8.17 17 7.13 16.02 6.75 14.36",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1201 18.18C12.8301 18.96 11.9801 19.55 10.8401 19.16C10.2701 18.96 9.6001 18.67 9.6001 16.91",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5901 18.17C14.0098 18.17 14.3501 17.8208 14.3501 17.39C14.3501 16.9592 14.0098 16.61 13.5901 16.61C13.1703 16.61 12.8301 16.9592 12.8301 17.39C12.8301 17.8208 13.1703 18.17 13.5901 18.17Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4902 10.86C18.0902 10.63 19.3202 9.25996 19.3302 7.59996C19.3302 5.95996 18.1402 4.59997 16.5702 4.33997",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgProvider = function SvgProvider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProvider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/provider.dc5e5082.svg";
export { ForwardRef as ReactComponent };